import axios from 'axios';
import {backendHost} from '../../config';

export const getBrands = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/brands`, {params});
};